export const strings = {
  en: {
    title: ({ causeName = "" }) => `Your Subscription is Going Towards ${causeName} With Every Order`,
    futureTenseTitle: ({ causeName = "" }) => `Your Subscription Will Go Towards ${causeName} With Every Order`,
    ctaMessagePrefix: () => `At no extra cost, `,
    description: ({ nonprofit = "" }) => `1% will be donated to ${nonprofit} for you, at no extra cost, every order.`,
    personalImpactTitle: () => `You're Currently Funding`,
    futureTensePersonalImpactTitle: () => `You’ll Be Funding`,
    communityImpactTitle: () => `Together We're Funding`,
    personalLinkCopy: ({ nonprofit = "", hideArrow = false }) => `Learn about ${nonprofit}${!hideArrow ? " ›" : ""}`,
    communityLinkCopy: ({ brandName = "", hideArrow = false }) =>
      `Learn about ${brandName} impact${!hideArrow ? " ›" : ""}`,
    percentFunded: () => `funded`,
    progressPillText: () => `🎉 Impact begins once order is charged`,
  },
  fr: {
    title: ({ causeName = "" }) => `Votre abonnement contribue à ${causeName} à chaque commande`,
    futureTenseTitle: ({ causeName = "" }) => `Votre abonnement contribuera à ${causeName} à chaque commande`,
    ctaMessagePrefix: () => `Sans frais supplémentaires, `,
    description: ({ nonprofit = "" }) =>
      `1% de chaque commande sera reversé à ${nonprofit} pour vous, sans frais supplémentaires.`,
    personalImpactTitle: () => `Vous financez actuellement`,
    futureTensePersonalImpactTitle: () => `Vous financerez`,
    communityImpactTitle: () => `Ensemble, nous finançons`,
    personalLinkCopy: ({ nonprofit = "", hideArrow = false }) =>
      `En savoir plus sur ${nonprofit}${!hideArrow ? " ›" : ""}`,
    communityLinkCopy: ({ brandName = "", hideArrow = false }) =>
      `En savoir plus sur l’impact de ${brandName}${!hideArrow ? " ›" : ""}`,
    percentFunded: () => `financé`,
    progressPillText: () => `🎉 L’impact commence une fois la commande débitée`,
  },
  de: {
    title: ({ causeName = "" }) => `Ihr Abonnement unterstützt ${causeName} mit jeder Bestellung`,
    futureTenseTitle: ({ causeName = "" }) => `Ihr Abonnement wird ${causeName} mit jeder Bestellung unterstützen`,
    ctaMessagePrefix: () => `Ohne zusätzliche Kosten, `,
    description: ({ nonprofit = "" }) =>
      `1% jeder Bestellung wird im Rahmen Ihres Abonnements an ${nonprofit} gespendet.`,
    personalImpactTitle: () => `Sie unterstützen derzeit`,
    futureTensePersonalImpactTitle: () => `Sie werden unterstützen`,
    communityImpactTitle: () => `Gemeinsam unterstützen wir`,
    personalLinkCopy: ({ nonprofit = "", hideArrow = false }) =>
      `Mehr über ${nonprofit} erfahren${!hideArrow ? " ›" : ""}`,
    communityLinkCopy: ({ brandName = "", hideArrow = false }) =>
      `Mehr über die Wirkung von ${brandName} erfahren${!hideArrow ? " ›" : ""}`,
    percentFunded: () => `finanziert`,
    progressPillText: () => `🎉 Wirkung beginnt, sobald die Bestellung abgerechnet wird`,
  },
  es: {
    title: ({ causeName = "" }) => `Tu suscripción está apoyando a ${causeName} con cada pedido`,
    futureTenseTitle: ({ causeName = "" }) => `Tu suscripción apoyará a ${causeName} con cada pedido`,
    ctaMessagePrefix: () => `Sin coste adicional, `,
    description: ({ nonprofit = "" }) => `El 1% de cada pedido se donará a ${nonprofit} en tu nombre.`,
    personalImpactTitle: () => `Actualmente estás financiando`,
    futureTensePersonalImpactTitle: () => `Financiarás`,
    communityImpactTitle: () => `Juntos estamos financiando`,
    personalLinkCopy: ({ nonprofit = "", hideArrow = false }) =>
      `Conoce más sobre ${nonprofit}${!hideArrow ? " ›" : ""}`,
    communityLinkCopy: ({ brandName = "", hideArrow = false }) =>
      `Conoce más sobre el impacto de ${brandName}${!hideArrow ? " ›" : ""}`,
    percentFunded: () => `financiado`,
    progressPillText: () => `🎉 El impacto comienza una vez que se procese el pedido`,
  },
  it: {
    title: ({ causeName = "" }) => `Il tuo abbonamento sostiene ${causeName} con ogni ordine`,
    futureTenseTitle: ({ causeName = "" }) => `Il tuo abbonamento sosterrà ${causeName} con ogni ordine`,
    ctaMessagePrefix: () => `Senza alcun costo aggiuntivo, `,
    description: ({ nonprofit = "" }) => `L'1% di ogni ordine sarà donato a ${nonprofit} per te.`,
    personalImpactTitle: () => `Attualmente stai finanziando`,
    futureTensePersonalImpactTitle: () => `Finanzierai`,
    communityImpactTitle: () => `Insieme stiamo finanziando`,
    personalLinkCopy: ({ nonprofit = "", hideArrow = false }) =>
      `Scopri di più su ${nonprofit}${!hideArrow ? " ›" : ""}`,
    communityLinkCopy: ({ brandName = "", hideArrow = false }) =>
      `Scopri di più sull’impatto di ${brandName}${!hideArrow ? " ›" : ""}`,
    percentFunded: () => `finanziato`,
    progressPillText: () => `🎉 L’impatto inizia una volta che l’ordine è stato addebitato`,
  },
  pl: {
    title: ({ causeName = "" }) => `Twoja subskrypcja wspiera ${causeName} przy każdym zamówieniu`,
    futureTenseTitle: ({ causeName = "" }) => `Twoja subskrypcja będzie wspierać ${causeName} przy każdym zamówieniu`,
    ctaMessagePrefix: () => `Bez dodatkowych kosztów, `,
    description: ({ nonprofit = "" }) =>
      `1% z każdego zamówienia zostanie przekazane na rzecz ${nonprofit} w Twoim imieniu.`,
    personalImpactTitle: () => `Obecnie wspierasz`,
    futureTensePersonalImpactTitle: () => `Będziesz wspierać`,
    communityImpactTitle: () => `Razem wspieramy`,
    personalLinkCopy: ({ nonprofit = "", hideArrow = false }) =>
      `Dowiedz się więcej o ${nonprofit}${!hideArrow ? " ›" : ""}`,
    communityLinkCopy: ({ brandName = "", hideArrow = false }) =>
      `Dowiedz się więcej o wpływie ${brandName}${!hideArrow ? " ›" : ""}`,
    percentFunded: () => `sfinansowano`,
    progressPillText: () => `🎉 Wpływ rozpoczyna się po zrealizowaniu zamówienia`,
  },
  ja: {
    title: ({ causeName = "" }) => `Your Subscription is Going Towards ${causeName} With Every Order`,
    futureTenseTitle: ({ causeName = "" }) => `Your Subscription Will Go Towards ${causeName} With Every Order`,
    ctaMessagePrefix: () => `At no extra cost, `,
    description: ({ nonprofit = "" }) => `1% will be donated to ${nonprofit} for you, at no extra cost, every order.`,
    personalImpactTitle: () => `You're Currently Funding`,
    futureTensePersonalImpactTitle: () => `You’ll Be Funding`,
    communityImpactTitle: () => `Together We're Funding`,
    personalLinkCopy: ({ nonprofit = "", hideArrow = false }) => `Learn about ${nonprofit}${!hideArrow ? " ›" : ""}`,
    communityLinkCopy: ({ brandName = "", hideArrow = false }) =>
      `Learn about ${brandName} impact${!hideArrow ? " ›" : ""}`,
    percentFunded: () => `支援済み`,
    progressPillText: () => `🎉 Impact begins once order is charged`,
  },
};
